import React from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';

const WasteReceiverToolbarActions = ({ tab, saving, loadingUsers, userLoadError }) => {
    const {
        cancelDraft,
        draftMode,
        isCreating,
        requestDeleteWasteReceiver,
        saveDraft,
        startCreate,
    } = tab;

    return (
        <>
            {draftMode !== 'view' && (
                <>
                    {!isCreating && (
                        <Button
                            variant="outlined"
                            startIcon={<DeleteIcon />}
                            onClick={requestDeleteWasteReceiver}
                            disabled={saving || loadingUsers || Boolean(userLoadError)}
                            className="setup-danger-button"
                        >
                            Slet
                        </Button>
                    )}
                    <Button variant="outlined" onClick={cancelDraft} disabled={saving}>
                        Annuller
                    </Button>
                    <Button
                        variant="contained"
                        startIcon={<SaveIcon />}
                        onClick={saveDraft}
                        disabled={saving || loadingUsers || Boolean(userLoadError)}
                    >
                        {isCreating ? 'Opret' : 'Gem'}
                    </Button>
                </>
            )}
            <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={startCreate}
                disabled={saving || isCreating}
            >
                Ny affaldsmodtager
            </Button>
        </>
    );
};

export default WasteReceiverToolbarActions;
